export default (theme) => ({
  hTStyle1: {
    fontSize: 20,
    fontWeight: 600,
    color: "#D93B44",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
    width: "100%",
  },
  pageContent: {
    marginLeft: 256,
  },
});
